import dayjs from "dayjs";
import weekday from 'dayjs/plugin/weekday'
import customParseFormat from 'dayjs/plugin/customParseFormat' 

dayjs.extend(customParseFormat);
dayjs.extend(weekday);

export const ultimoDiaUtilDoMesAtual = () => {
    let diaUltimoDiaDoMes = dayjs().endOf('month').weekday();
    let aux = diaUltimoDiaDoMes < 5  ? 0 : (diaUltimoDiaDoMes === 5 ? -1 : -2) ;
    return dayjs().endOf('month').add(aux, 'day');
} 

export const adicionarMes = (data, qtdMeses) => {
    var result = new Date(data);
    result.setMonth(data.getMonth() + qtdMeses);
    return result;
};

export const intToMonth = (i) => {
    return [
        'JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN',
        'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'
    ][i - 1];
}

export const inverterData = function(datastr) {
    var data = datastr.split('-');
    data = data[2] + '-' + data[1] + '-' + data[0];
    return data;
};

export const diasAntes = (date, days) => {
    var result = new Date(date);
    result.setDate(result.getUTCDate() - days);
    return result;
};

export const extrairAno = data => {
    return data.substring(0, 4);
};

export const extrairMes = data => {
    return data.substring(5, 7);
};

export const extrairFormatoMesAno = data => {
    return data.substring(5, 7) + '/' + data.substring(0, 4);
};

export const formataDataISO = (value) => {
    if (/^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/.test(value)) {      // YYYY-MM-DD (ISO 8601)
        return value;
    } else if (/^(0[1-9]|[12]\d|3[01])\/(0[1-9]|1[0-2])\/(\d{4})$/.test(value)) {    // DD/MM/YYYY
        return [RegExp.$3, RegExp.$2, RegExp.$1].join("-");
    } else if (/^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/(\d{4})$/.test(value)) {    // MM/DD/YYYY
        return [RegExp.$3, RegExp.$1, RegExp.$2].join("-");
    } else {
        throw new Error("Formato de data esperado: aaaa-mm-dd, dd/mm/aaaa ou mm/dd/aaaa");
    }
};

export const calcularIdade = (dateString) => {
    var today = new Date();
    var birthDate = new Date(dateString);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getUTCDate() < birthDate.getUTCDate())) {
        age--;
    }
    return age;
}

export const calcularIdadeBr = (dateString) => {
    const [day, month, year] = dateString.split("/")
    var today = new Date();
    var birthDate = new Date(year, month - 1, day);
    var age = today.getFullYear() - birthDate.getFullYear();
    var m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getUTCDate() < birthDate.getUTCDate())) {
        age--;
    }
    return age;
}

export const groupBy = function(xs, key) {
    return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
    }, {});
};

export const isDataStrISOValida = (dataStr) => (
    dayjs(dataStr).isValid()
)

export const isDataStrValida = (dataStr, mask) => (
    dayjs(dataStr, mask, true).isValid()
)

/**
 * Competências no formato MM/YYYY
 * @param {MM/YYYY} competenciaFinal 
 * @param {MM/YYYY} competenciaInicial 
 * @returns 
 */
export const isCompetenciaMaior = (competenciaMaior, competenciaMenor) => {
    const aCompetenciaMaior = competenciaMaior?.split('/');
    const aCompetenciaMenor = competenciaMenor?.split('/');
    if (aCompetenciaMaior?.length === 2 && aCompetenciaMenor?.length === 2) {
        const mesMaior = Number(aCompetenciaMaior[0]);
        const mesMenor = Number(aCompetenciaMenor[0]);
        const anoMaior = Number(aCompetenciaMaior[1]);
        const anoMenor = Number(aCompetenciaMenor[1]);
      if (anoMaior > anoMenor) {
        return true;
      }
      return (anoMaior === anoMenor && mesMaior > mesMenor);
    }
    return false;
  };

export const isCompetenciaValida = (competencia) => {  
    const isDataVazia = !competencia;
    const formato = 'MM/YYYY';
    const parse = dayjs(competencia, formato, true);
    return isDataVazia || parse.isValid();
};

export const isDataValida = (data, disableFuture = false) => {  
    const dataVazia = !data;
    const formato = 'DD/MM/YYYY';
    const parse = dayjs(data, formato, true);
    const isFutura = disableFuture && parse.isAfter(dayjs());
    return (dataVazia || (parse.isValid() && !isFutura));
};

export const obterQuantidadeDeMesesEntreDatas = (dataInicial, dataFinal) => {
    const anoInicial = dataInicial.getFullYear();
    const mesInicial = dataInicial.getMonth();
    const anoFinal = dataFinal.getFullYear();
    const mesFinal = dataFinal.getMonth();

    return (anoFinal - anoInicial) * 12 + (mesFinal - mesInicial);
}

/* competencia: MM/YYYY */
export const converterCompetenciaEmData = (competencia) => {
    const [mes, ano] = competencia.split('/');
    return new Date(parseInt(ano), parseInt(mes) - 1);
}